(ns common.resource.advertiser
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(def collection-url (:api/advertisers url-tpl/templates))
(def instance-url (:api/advertiser url-tpl/templates))

;; Post advertiser
(rf/reg-event-fx :resource.advertiser/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc db :resource.advertiser/post {:state :pending})
     :http
     {:method :post
      :params payload
      :uri (url-tpl/render collection-url url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.advertiser/post-success]
      :on-failure [:resource.advertiser/post-failure]}}))

(rf/reg-event-db :resource.advertiser/post-success
  (fn [db _]
    (assoc db :resource.advertiser/post {:state :success})))

(rf/reg-event-db :resource.advertiser/post-failure
  (fn [db _]
    (assoc db :resource.advertiser/post {:state :failure})))

;; Patch advertiser
(rf/reg-event-fx :resource.advertiser/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc db :resource.advertiser/patch {:state :pending})
     :http
     {:method :patch
      :params payload
      :uri (url-tpl/render instance-url url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.advertiser/patch-success]
      :on-failure [:resource.advertiser/patch-failure]}}))

(rf/reg-event-fx :resource.advertiser/patch-success
  (fn [{:keys [db]} [_ value]]
    {:db (assoc db :resource.advertiser/patch {:state :success}
                :resource.advertiser/one {:state :success
                                          :value value})
     :fx [[:invalidate-queries {:queryKey ["advertiser" (:id value)]}]]}))

(rf/reg-event-db :resource.advertiser/patch-failure
  (fn [db _]
    (assoc db :resource.advertiser/patch {:state :failure})))

(rf/reg-event-db :resource.advertiser/get-one-success
  (fn [db [_ advertiser]]
    (assoc db :resource.advertiser/one {:state :success
                                        :value advertiser})))

(rf/reg-sub :resource.advertiser/one
  (fn [db]
    (:resource.advertiser/one db)))

(rf/reg-sub :resource.advertiser/whitelisted-urls
  :<- [:resource.advertiser/one]
  (fn [advertiser _]
    (get-in advertiser [:value :allowedClickurlDomains])))
